import type { ErrorLink } from '@apollo/client/link/error';
import { onError } from '@apollo/client/link/error';
import { captureException, withScope } from '@sentry/nextjs';

export const customErrorHandler: ErrorLink.ErrorHandler = ({
  networkError,
}) => {
  const maintenanceRegex = /Received status code 503/;
  if (typeof window !== 'undefined' && networkError) {
    if (
      maintenanceRegex.test(networkError.message) &&
      window.location.pathname !== '/maintenance'
    ) {
      window.location.replace('/maintenance');
    } else {
      withScope((scope) => {
        scope.setTag('source', 'apollo-link-error');
        captureException(networkError);
      });
    }
  }
};

export const errorLink = onError(customErrorHandler);
